import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Card, } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LoaderInfiniteLoop from 'widgets/loaderInfiniteLoop';
import IconAlert from 'components/common/IconAlert';
import Flex from 'components/common/Flex';
import { useDropzone } from 'react-dropzone';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import { Link } from 'react-router-dom';
import nl2br from 'react-nl2br';

import { Axios } from 'helpers/axios';
import { AxiosUpload } from 'helpers/axiosFileUpload';

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { requestDocToOrga } from 'helpers/yupValidationSchema';

const DemandeDocsOrga = () => {
    let { docRequestPublicCode } = useParams();
    const [showCloseState, setShowCloseState] = useState(false);
    const [showSuccessState, setShowSuccessState] = useState(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [demande, setDemande] = useState();

    const initRequest = async () => {
        try {
            const getDemandeDetails = await Axios.post('/publicRoutes/getDemandeDocsOrga',{
                docRequestPublicCode: docRequestPublicCode,
            });
            setDemande(getDemandeDetails.data.demande);

            setValue("nbMaxDocDemande", getDemandeDetails.data.demande.nbMaxDocDemande);
            setValue("formatDocument", getDemandeDetails.data.demande.formatDocument);

            setIsLoading(false);
        } catch (error) {
            setShowCloseState(true);
            setIsLoading(false);
        }
    }

    useEffect(()=>{
        initRequest();
    },[])

    const { handleSubmit, setValue, watch } = useForm({
        resolver: yupResolver(requestDocToOrga),
    });

    const [files, setFiles] = useState([]);
    const { getRootProps, getInputProps } = useDropzone({
        maxFiles: demande ? demande.nbMaxDocDemande - files.length : 0,
        multiple: true,
        onDrop: acceptedFiles => {
            const tempArray = files;
            for(const file of acceptedFiles)
            {
                if(!demande.formatDocument || file.path.split('.').pop() == demande.formatDocument)
                {
                    tempArray.push(file);
                }
            }
            setFiles([...tempArray]);
        }
    });

    const handleRemove = (path) => {
        setFiles(files.filter(file => file.path != path));
    };

    useEffect(()=>{
        if(files.length == 0 && watch("uploadedFiles") && Array.isArray(watch("uploadedFiles")))
        {
            setFiles(watch("uploadedFiles"));
        }
    },[])

    useEffect(()=>{
        if(files)
        {
            setValue("files", files);
        }
    },[files])

    const envoyerFichiers = async (data) => {
        try {
            setIsLoading(true);

            for(const file of data.files)
            {
                let formData = new FormData();
                formData.append('file', file);
                formData.append('nomDocumentDPS', file.name);
                formData.append('idDocRequest', demande.idDocRequest);
                formData.append('idDPS', demande.idDPS);
                formData.append('idTypeDocument', demande.idTypeDocument);
                formData.append('docRequestPublicCode', docRequestPublicCode);

                await AxiosUpload.post('/publicRoutes/uploadDpsDocFromOrga', formData);
            }

            await Axios.post('/publicRoutes/dropDemandeDocOrgaSuiteUpload',{
                docRequestPublicCode: docRequestPublicCode,
            });

            setShowSuccessState(true);
            setIsLoading(false);

        } catch (error) {
            console.error(error)
            setShowSuccessState(false);
        }
    }

    if(isLoading)
    {
        return <LoaderInfiniteLoop />
    }else{
        if(showCloseState)
        {
            return <IconAlert variant={'info'}>Cette demande a déjà été traitée. Merci !</IconAlert>
        }else{
            return(
                <Card>
                    <Card.Body>
                        <p className="text-center">
                            <h4><b>{demande.libelleDPS}</b></h4>
                            <h5>Demande de documents</h5>
                            {nl2br(demande.textDemande)}
                        </p>

                        {showSuccessState == true ?
                            <IconAlert variant={'success'}>Merci pour vos documents ! Vous pouvez fermer cette page.</IconAlert>
                        :
                            showSuccessState == false ?
                                <IconAlert variant={'danger'}>Une erreur s'est produite, merci de ré-essayer.</IconAlert>
                            :
                                <>
                                    {!demande.nbMaxDocDemande || files.length < demande.nbMaxDocDemande ? <>
                                        <div {...getRootProps({ className: 'dropzone-area py-6' })}>
                                            <input name="uploadedFiles" {...getInputProps()} />
                                            <Flex justifyContent="center">
                                                <img src={cloudUpload} alt="" width={25} className="me-2" />
                                                <p className="fs-9 mb-0 text-700">Déposez vos fichiers ici</p>
                                            </Flex>
                                        </div>
                                        <center><i>
                                            {demande.nbMaxDocDemande || demande.formatDocument ? "Attentu: " : null}
                                            {demande.nbMaxDocDemande ? demande.nbMaxDocDemande+" document(s) " : null}
                                            {demande.formatDocument ? "au format "+demande.formatDocument : null}
                                        </i></center>
                                    </>: null}

                                    <div className="mt-3">
                                        {files.length > 0 && (
                                            <>
                                                <h6>Fichiers:</h6>
                                                <ul>
                                                    {files.map(file => (
                                                        <li key={file.path}>
                                                            {file.name} <Link className='text-danger' onClick={()=>{handleRemove(file.path)}}><FontAwesomeIcon icon='trash' /></Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </>
                                        )}
                                    </div>

                                    <div className="mt-3">
                                        {files.length > 0 && (
                                            <>
                                                <Button className='w-100' onClick={()=>{handleSubmit(envoyerFichiers)()}} disabled={files.lenght < 1}>Envoyer</Button>
                                            </>
                                        )}
                                    </div>
                                </>
                        }
                    </Card.Body>
                </Card>
            )
        }
    }
};

export default DemandeDocsOrga;